/* eslint-disable */
import _ from 'lodash'
import * as types from '../store/mutations-types'
import store from '../store'
import moment from 'moment'


export const headers = [
  'Numero',
  'moyenne',
  'type',
  'secteur',
  'lat',
  'long',
]

export default function rowToObject(data, secteurs, contenants) {
  var output = []
  for (let index = 0; index < data.length; index++) {
    let item = data[index];
    item = item.map((i, idx) => (idx !== 2 && idx !== 3) ? String(i).trim() : i);

    if (!_isEmtyOrNull(item[0]) && !_isEmtyOrNull(item[1]) && !_isEmtyOrNull(item[2]) &&
      !_isEmtyOrNull(item[3]) && !_isEmtyOrNull(item[4]) && !_isEmtyOrNull(item[5]) && !_isEmtyOrNull(item[6])) {
      var flag = true
      var tempRow = { }

      let contenant = contenants.find(contenant => contenant.reference === item[0])

      if (contenant !== undefined){
        store.dispatch('showErrorMessage','Un contenant avec le numéro '+item[0]+' existe déjà dans la base !')
        flag = false
        continue
      }

      let secteur = secteurs.find(secteur => secteur.nom === item[4]);
      if (secteur === undefined || secteur === null){
        store.dispatch('showErrorMessage','Un des secteurs saisis est non défini')
        continue
      }

      if (item[1].toUpperCase() === 'CORBEILLE' || item[1].toUpperCase() === 'CANIBOX')
        tempRow.typeContenant = item[1].toUpperCase()
      else{
        store.dispatch('showErrorMessage','Un des types de contenants saisis est non défini')
        flag = false
        continue
      }
      tempRow.lat = parseFloat(item[2])
      tempRow.lon = parseFloat(item[3])
      tempRow.tauxDeRemplissage = 0.00
      tempRow.nombreDeCollecte = 0
      tempRow.actif = true
      tempRow.adresse = item[5]
      tempRow.numero = item[6]
      tempRow.reference = item[0]
      tempRow.secteur_id = secteur.id
      tempRow.arrondissement_id = secteur.arrondissement_id
      tempRow.ville_id = secteur.ville_id
      if (flag)
        output.push(tempRow)
    }
  }
  return output
}

var _isEmtyOrNull = function (element) {
  return element === null || element === undefined || element === ''
}



// WEBPACK FOOTER //
// ./src/utils/csvProps.js